<section class="app-outlet">
  <app-header></app-header>
  <main class="app-outlet__main">
    <div [ngClass]="[isSuperAdmin ? 'd-flex justify-content-between'  : '', ]">
      <app-navbar *ngIf="isSuperAdmin && isLoggedin"></app-navbar>
      <app-tab-view *ngIf="!isSuperAdmin && isLoggedin"></app-tab-view>
      <router-outlet>
      </router-outlet>
    </div>
  </main>
  <!-- <app-footer>
  </app-footer> -->
</section>
<p-toast position="bottom-center" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"></p-toast>